import { ApiBind, CommonSearchParam } from './common-search-param.model';


export class TopicsURLSearchParam extends CommonSearchParam {

  constructor(
    platformId?: number,
  ) {
    super();
    this.platformId = platformId;
  }

  @ApiBind({ column: 'platform_id' })
  platformId: number;
}
